module.exports = __webpack_public_path__ + "static/media/GOVTECH_logo.c32209aa.png";